import React from 'react';
import Modal from 'react-modal';
import { isNil, map, toUpper } from 'lodash';
import translateService from '../../../common/translateService';
import { scrollToSizeChart } from '../../../services/product/productInteraction';
import {
  getAvailabilityLabel,
  getAvailabilityCssClass,
} from '../../../services/product/productService';

const ProductOptionsSize = (props) => {
  Modal.setAppElement('body');

  const handleClick = (e) => {
    props.updateSelection(e, false);
    props.updateModalState(props.attrName);
  };

  const handleScrollToSizeChart = () => {
    scrollToSizeChart(props.sizeChartRef);
  };

  const handleModalStateChange = () => {
    props.updateModalState(props.attrName);
  };

  const sizeSelection = map(props.values, (v, i) => {
    const cssClassAvailability = getAvailabilityCssClass(
      props.isKit,
      props.selection,
      props.options,
      props.attrName,
      v.value,
      props.qtySelected,
    );
    const text = getAvailabilityLabel(
      props.isKit,
      props.selection,
      props.options,
      props.attrName,
      v.value,
      props.qtySelected,
    );

    return (
      <button
        type='button'
        className={`prd-option-size ${cssClassAvailability} ${
          v.value === props.selection[props.attrName] ? 'selected' : ''
        }`.trim()}
        data-value={v.value}
        data-attr={props.attrName}
        onClick={handleClick}
        key={i}
      >
        <span>{toUpper(v.value)}</span>
        {text}
      </button>
    );
  });

  return (
    <div className='prd-option prd-options-size'>
      <h2 className='prd-options-size-text'>
        <span className='prd-options-name'>{props.name}</span>
        {!isNil(props.sizeChartRef.current) && (
          <button
            type='button'
            className='prd-options-size-chart'
            onClick={handleScrollToSizeChart}
          >
            {translateService.get(`productDetail.sizeChart`)}
          </button>
        )}
      </h2>
      <div className='prd-options-size-select'>
        {props.isMobile ? (
          <>
            <button
              type='button'
              className='prd-modal-button open'
              onClick={handleModalStateChange}
            >
              <span
                className={
                  props.selection[props.attrName]
                    ? getAvailabilityCssClass(
                        props.isKit,
                        props.selection,
                        props.options,
                        props.attrName,
                        props.selection[props.attrName],
                        props.qtySelected,
                      )
                    : ''
                }
              >
                {props.selection[props.attrName] ? (
                  <>
                    <span>{toUpper(props.selection[props.attrName])}</span> -{' '}
                    {getAvailabilityLabel(
                      props.isKit,
                      props.selection,
                      props.options,
                      props.attrName,
                      props.selection[props.attrName],
                      props.qtySelected,
                    )}
                  </>
                ) : (
                  translateService.get(`productDetail.select`)
                )}
              </span>
              <span
                style={{
                  transform: 'rotate(90deg)',
                  marginRight: '4px',
                }}
              >
                &#9002;
              </span>
            </button>
            <Modal
              isOpen={props.modalsState[props.attrName]}
              onRequestClose={handleModalStateChange}
              contentLabel={translateService.get(`productDetail.selectSize`)}
              closeTimeoutMS={500}
              className={{
                base: 'prd-modal-content',
                afterOpen: 'prd-modal-content-afterOpen',
                beforeClose: 'prd-modal-content-beforeClose',
              }}
              overlayClassName={{
                base: 'prd-modal-overlay',
                afterOpen: 'prd-modal-overlay-afterOpen',
                beforeClose: 'prd-modal-overlay-beforeClose',
              }}
              shouldFocusAfterRender={false}
            >
              <div className='prd-options-size-wrapper'>
                <div className='prd-options-heading'>
                  <h3>{translateService.get(`productDetail.selectSize`)}</h3>
                  <button
                    type='button'
                    className='prd-modal-button close'
                    onClick={handleModalStateChange}
                  >
                    &times;
                  </button>
                </div>
                <div className='prd-options-size-container'>
                  {sizeSelection}
                </div>
              </div>
            </Modal>
          </>
        ) : (
          sizeSelection
        )}
      </div>
    </div>
  );
};

export default ProductOptionsSize;
